import HttpFactory from '../factory'
import type { MonitorAssignment } from '../types/monitor/monitorAssignment'
import type { PageOfMonitoringPeriod } from '../types/monitor/monitoringPeriod'

class MonitorsModule extends HttpFactory<any[]> {
  private RESOURCE = '/v3/monitors'

  async get(id: string): Promise<MonitorAssignment[]> {
    return await this.call<any>('GET', `${this.RESOURCE}/?patientId=${id}`)
  }

  async assignMonitor(data: any, monitorId: string, patientId: string): Promise<MonitorAssignment> {
    return await this.call<any>('POST', `${this.RESOURCE}/${monitorId}/patients/${patientId}`, data)
  }

  async updateAssignMonitor(
    data: any,
    monitorId: string,
    patientId: string,
    revisionId: string,
  ): Promise<MonitorAssignment> {
    return await this.call<any>('PATCH', `${this.RESOURCE}/${monitorId}/patients/${patientId}?revision=${revisionId}`, data)
  }

  async getMonitorHistory(patientId: string, readAfterKey?: string): Promise<PageOfMonitoringPeriod> {
    const params: any = { patientId }
    if (readAfterKey) {
      params.readAfterKey = readAfterKey
    }
    return await this.call<PageOfMonitoringPeriod>('GET', `${this.RESOURCE}/periods`, undefined, { params })
  }

  async unAssignMonitor(data: any, monitorId: string, patientId: string, revisionId: string): Promise<MonitorAssignment> {
    return await this.call<any>('DELETE', `${this.RESOURCE}/${monitorId}/patients/${patientId}?revision=${revisionId}`, data)
  }
}

export default MonitorsModule
